export default __webpack_public_path__ + "static/media/ic_challenges_1.69ae63f0.svg";